import { API, authClient } from "../index";

export const postProductMarca = async (marca, accessToken) => {
  return authClient(accessToken).post(`${API}/product-marcas`, marca);
};

export const getProductMarcas = (accessToken) => {
  return authClient(accessToken).get(`${API}/product-marcas`);
};

export const getProductMarcaById = (id, accessToken) => {
  return authClient(accessToken).get(`${API}/product-marcas/${id}`);
};

export const updateProductMarca = async (id, marca, accessToken) => {
  return authClient(accessToken).put(`${API}/product-marcas/${id}`, marca);
};

export const deleteProductMarca = (id, accessToken) => {
  return authClient(accessToken).delete(`${API}/product-marcas/${id}`);
};
